import entitiesReducer from './entitiesReducer'
export default entitiesReducer